const session = {
  logOut({ commit }) {
    // Reset Session
    commit('setState', {
      path: 'sessionExists',
      value: false,
    });
    commit('setState', {
      path: 'authHeader',
      value: '',
    });
  },
};

/* ACTIONS: Putting it all together */
const actions = {
  bulkSetState({ commit }, payload) {
    for (let key in payload) {
      commit('setState', {
        path: key,
        value: payload[key]
      });
    }
  },
  bulkMutation({ commit }, mutationObj) {
    for (const mutation in mutationObj) {
      commit(mutation, mutationObj[mutation]);
    }
  },
  ...session,
};

export default actions;
